import { render, staticRenderFns } from "./ClassBody.vue?vue&type=template&id=5aaf73ae&scoped=true&"
import script from "./ClassBody.vue?vue&type=script&lang=js&"
export * from "./ClassBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf73ae",
  null
  
)

export default component.exports